<script>
  export let year;
  export let even;
  export let slideWidth;
  export let empty;

  import { windowHeight, isMobile } from "../../stores/global.js";

  $: midpoint = slideWidth / 2;
  $: width = midpoint + slideWidth;
  $: zeroPosition = midpoint - slideWidth;
  $: height = $isMobile ? $windowHeight - 39 : $windowHeight;

  $: evenPath = `${midpoint}, 0 ${zeroPosition}, ${height} ${width}, ${height}`;
  $: oddPath = `${zeroPosition} 0, ${midpoint} ${height}, ${width} 0`;
</script>

<svg
  class="triangle-container {even ? 'even' : 'odd'} {empty ? 'empty' : ''}"
  height="100%"
  width="100%"
>
  {#if even == true}
    <defs>
      <linearGradient id="gradient{year}" x1="0%" y1="{0}%" x2="0%" y2="{100}%">
        <stop offset="0%" style="stop-color: #5189c9; stop-opacity: 1" />
        <stop offset="100%" style="stop-color: #4B538F; stop-opacity: 1" />
      </linearGradient>
    </defs>
    <polygon
      points={evenPath}
      id="triangle{year}"
      class="triangle"
      fill="url(#gradient{year})"
    />
  {:else}
    <defs>
      <linearGradient id="gradient{year}" x1="0%" y1="{0}%" x2="0%" y2="{100}%">
        <stop offset="0%" style="stop-color: #4B538F; stop-opacity:1" />
        <stop offset="100%" style="stop-color: #5189c9; stop-opacity:1" />
      </linearGradient>
    </defs>
    <polygon
      points={oddPath}
      id="triangle{year}"
      class="triangle"
      fill="url(#gradient{year})"
    />
  {/if}
</svg>

<style>
  .triangle-container {
    position: absolute;
    /* z-index: 1; */
    pointer-events: none;
    user-select: none;
    overflow: visible;
    filter: brightness(0.7);
    /* filter: brightness(0.7) drop-shadow(0px 0px 10px rgba(0, 0, 0, 0)); */
    /* transform: scaleX(1);
    -webkit-transform: scaleX(1); */
    transition: transform 600ms ease 300ms, filter 400ms linear 300ms;
    will-change: transform, filter;
  }

  .triangle {
    stroke-width: 0;
    pointer-events: none;
    user-select: none;
    /* transition: filter 300ms linear 300ms; */
  }

  :global(.swiper-slide-active .triangle-container) {
    z-index: 2;
    filter: brightness(1);
    /* filter: brightness(1) drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3)); */
    transition: transform 700ms ease, filter 300ms linear 300ms;
  }

  /* Only apply drop shadow to first and last slide (for contrast with edges), 
  Using for all slides tanks performance */
  :global(.slide-2021.swiper-slide-active
      .triangle-container, .slide-1971.swiper-slide-active
      .triangle-container) {
    filter: brightness(1) drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3));
  }

  @media screen and (min-width: 768px) {
    :global(.swiper-slide-active .triangle-container) {
      transform: scaleX(2.2);
    }
  }

  @media screen and (max-width: 767px) {
    :global(.swiper-slide-active .triangle-container) {
      transform: scaleX(1.5);
    }
  }
</style>
